module.exports = __webpack_public_path__ + "static/img/5-2-1.7d296360.jpg";